import React from "react";
import AnalyticsContent from "../components/Analytics/Analytics";
import MainLayout from "../components/MainLayout/MainLayout";

function Analytics() {
  return (
    <MainLayout>
      <AnalyticsContent />
    </MainLayout>
  );
}

export default Analytics;